import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import TicketEmailAddressForm from './TicketEmailAddressForm';

// The list of service desk email addresses per division, shown below the settings
const TicketEmailAddressList: React.FC = () => {

    // Specify the columns of this list
    const columns: ListColumnType[] = [
        {
            width: '2fr',
            field: 'division_name',
            label: 'ticket.settings.email_address_division_label'
        },
        {
            width: '3fr',
            field: 'email',
            label: 'ticket.settings.email_address_title',
            render: (_, row) => <>{row.email || '-'}</>
        },
    ];

    return (
        <AbstractList
            query={{
                endpoint: 'get_ticket_email_address_list',
                object: 'ticket_email_address'
            }}
            objectName='ticket.settings.email_address_object_name'
            headerTitle='ticket.settings.email_addresses_title'
            columns={columns}
            showAddButton={false}
            showSearch={false}
            isPaginated={false}
            editModal={{ modal: <TicketEmailAddressForm />, modalSize: 'small' }}
            onRowClick='editModal'
        />
    );
};

export default TicketEmailAddressList;
